export default __webpack_public_path__ + "static/touch-3951de4fff7863e89d3a31540c264ab6.png";